import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { formatCost } from '../formatting.utils';
import { CostFormattingOptions } from '../model';

/**
 * Cost formatting pipe. Use cost, currency and period data for propper displaying string
 */
@Pipe({
  name: 'cost',
})
export class CostPipe implements PipeTransform {
  constructor(private readonly sanitize: DomSanitizer) {}

  /**
   * Transform cost string into formatted value
   *
   * @param cost - cost string
   * @param options
   */
  transform(cost: string, options?: CostFormattingOptions): SafeHtml {
    return this.sanitize.bypassSecurityTrustHtml(
      formatCost(cost, this.sanitize, options),
    );
  }
}
